import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  VStack,
  Button,
  Flex,
  Image,
  useBreakpointValue,
  useToast
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import BackGroundImage from "../resources/PlatformBackround.png"
import { useColorModeValue } from "@chakra-ui/react";
import ReCAPTCHA from 'react-google-recaptcha';

type TenantOption = {
  value: string;
  label: string;
};




const TenantSelector: React.FC = () => {

const [token, setToken] = useState<string | null>(localStorage.getItem("token"));

const selectBorderColor = useColorModeValue("#CBD5E0", "#4A5568"); // gray.300 / gray.600
const selectFocusBorderColor = useColorModeValue("#2B6CB0", "#63B3ED"); // blue.600 / blue.300
const selectTextColor = useColorModeValue("#2B6CB0", "#63B3ED"); // blue.600 / blue.300
const placeholderColor = useColorModeValue("#718096", "#A0AEC0"); // gray.500 / gray.400
const menuBgColor = useColorModeValue("white", "#2D3748"); // white / gray.800
const optionHoverBg = useColorModeValue("#BEE3F8", "#2C5282"); // blue.100 / blue.700

const showFeatureHighlight = useBreakpointValue({ base: false, md: true });

  const [tenantOptions, setTenantOptions] = useState<TenantOption[]>([]);
  const [filteredOptions, setFilteredOptions] = useState<TenantOption[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<TenantOption | null>(null);
  const navigate = useNavigate();

  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
  const [recaptchaError, setRecaptchaError] = useState<string | null>(null);


  const handleRecaptchaChange = (token: string | null) => {
    setRecaptchaToken(token);
    setRecaptchaError(null); // Clear error if recaptcha passes
  };

  const handleRecaptchaError = () => {
    setRecaptchaError('Failed to verify reCAPTCHA. Please try again.');
  };

  const toast = useToast();

  const recaptchaKey = process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;

  if (!recaptchaKey) {
    throw new Error('REACT_APP_GOOGLE_CAPTCHA_KEY is not defined');
  }

  useEffect(() => {
    const fetchTenants = async () => {
      try {

        const apiUrl = process.env.REACT_APP_API_URL;
        const res = await axios.get(`${apiUrl}/public/tenants`);
        const options = res.data.map((tenant: any) => ({
          value: tenant.tenant_slug,
          label: tenant.tenant_name,
        }));
        setTenantOptions(options);
      } catch (error) {
        console.error("Failed to fetch tenants", error);
      }
    };
    fetchTenants();
  }, []);

    const handleInputChange = (input: string) => {
    if (!input) {
      setFilteredOptions([]);
    } else {
      const filtered = tenantOptions.filter(t =>
        t.label.toLowerCase().includes(input.toLowerCase())
      );
      setFilteredOptions(filtered);
    }
  };

  const handleGoClick = async () => {

      if (!recaptchaToken) {
          alert('Please complete the reCAPTCHA verification.');
          setRecaptchaError('Please complete the reCAPTCHA verification.');
            return;
          }      

          const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";

          // Send the CAPTCHA token to your backend for verification
          const response = await fetch(apiurl+"/verify-captcha", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ recaptchaToken }),
        });

        const data = await response.json();

        if (data.success) {
          // alert("CAPTCHA verified successfully!");
          // Proceed with form submission logic
        } else {
          toast({
            title: 'Captcha Failed',
            description:
              'Captcha Verification Failed. Please try again.',
            status: 'error',
            duration: 5000,
            isClosable: true,
          });
          return;
        }


    if (selectedTenant) {
      navigate(`/platform/${selectedTenant.value}`);
    }
  };

return (
  <Box
    bgImage={BackGroundImage}
    bgSize="cover"
    bgPosition="center"
    height="calc(100vh - 72px)"
    width="100%"
    position="relative"
    overflow="hidden"
    mt="72px"
    display="flex"
    flexDirection="column"
    justifyContent="space-between"
    px={4}
  >
    {/* Headings + Feature Highlight */}
    <Box pt="5%" textAlign="center" zIndex={1}>
      <Text
        fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
        fontWeight="bold"
        color="blue.500"
        textShadow="1px 1px 4px rgba(0, 0, 0, 0.4)"
        mb={2}
      >
        Eduvic Learning Platform
      </Text>
    {/*   {showFeatureHighlight && <FeatureHighlightSection />} */}
    </Box>

    {/* Dropdown + Button */}
  {!token && (
    <Flex
      direction="column"
      align="center"
      justify="center"
      mb="10%"
      zIndex={2}
    >
      <VStack spacing={4} minW="280px" maxW="300px" w="90%">
        <Select
          options={filteredOptions}
          placeholder="Search for your org..."
          onChange={(option) => setSelectedTenant(option)}
          onInputChange={handleInputChange}
          isSearchable
          noOptionsMessage={() => "Start typing to see orgs.."}
          styles={{
            container: (base) => ({
              ...base,
              width: "100%",
              minWidth: "280px",
            }),
            menu: (base) => ({
              ...base,
              zIndex: 99,
              backgroundColor: menuBgColor,
            }),
            control: (base, state) => ({
              ...base,
              backgroundColor: menuBgColor,
              borderColor: state.isFocused ? selectFocusBorderColor : selectBorderColor,
              boxShadow: state.isFocused ? `0 0 0 1px ${selectFocusBorderColor}` : undefined,
              "&:hover": {
                borderColor: selectFocusBorderColor,
              },
            }),
            singleValue: (base) => ({
              ...base,
              color: selectTextColor,
              fontWeight: "600",
            }),
            input: (base) => ({
              ...base,
              color: selectTextColor,
            }),
            placeholder: (base) => ({
              ...base,
              color: placeholderColor,
            }),
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isFocused ? optionHoverBg : menuBgColor,
              color: selectTextColor,
              fontWeight: state.isSelected ? "bold" : "normal",
              cursor: "pointer",
            }),
          }}
        />
      {recaptchaError && <Text color="red.500">{recaptchaError}</Text>}
    {/* Recaptcha */}
    <ReCAPTCHA sitekey={recaptchaKey} onChange={handleRecaptchaChange} onErrored={handleRecaptchaError} />
        <Button
          colorScheme="cyan"
          onClick={handleGoClick}
          isDisabled={!selectedTenant}
          w="full"
        >
          Let&apos;s Go!!
        </Button>
      </VStack>
    </Flex>

    )}

    {/* Footer Note */}
    <Box position="relative" bottom={0} width="100%" textAlign="center" px={4} pb={4}>
      <Text fontSize="md" color="gray.600">
        Eduvic Learning Platform – A multi-tenant learning platform with a shared assessment foundation for hybrid exams.
      </Text>
    </Box>
    </Box>
);

};

export default TenantSelector;